import { useState } from 'react'
import { ParagraphProps } from '~types'
import { parseHTMLString } from 'utils'
import styles from './Paragraph.module.scss'
import cx from 'classnames'

const Paragraph = ({
  color = 'lightest',
  fontSize = 'md',
  justify = 'left',
  noMarginBottom = false,
  text,
  readMoreText
}: ParagraphProps) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const handleToggle = () => setIsExpanded(prev => !prev)

  if (!text?.html || text?.html == '<p></p>') return null

  const classNames = [
    styles['paragraph-module'],
    `text-justify-${justify}`,
    'full-width',
    `font-size-${fontSize}`,
    `is-color-${color}`,
    noMarginBottom && 'mb-0'
  ].filter(Boolean)

  return (
    <div className={classNames.join(' ')}>
      {parseHTMLString(text)}

      {readMoreText?.html && readMoreText.html !== '<p></p>' && (
        <div className={styles['read-more-wrapper']}>
          <div
            className={cx(styles['read-more-content'], {
              [styles['open']]: isExpanded
            })}
          >
            {parseHTMLString(readMoreText)}
          </div>
          <button
            onClick={handleToggle}
            className={cx(styles['read-or-hide'], justify === 'center' && styles['read-or-hide-center'])}
          >
            {isExpanded ? 'Read Less' : 'Read More'}
            <div className={cx(styles['caret'], { [styles['is-open']]: !isExpanded })} />
          </button>
        </div>
      )}
    </div>
  )
}

export default Paragraph
